import ActiveProjectsChart from '@/components/dashboard/charts/ActiveProjectsChart.vue'
import PipelineStatusChart from '@/components/dashboard/charts/PipelineStatusChart.vue'
import EquipmentConditionChart from '@/components/dashboard/charts/EquipmentConditionChart.vue'
import OnTimeRepairsChart from '@/components/dashboard/charts/OnTimeRepairsChart.vue'
import GrossMarginChart from '@/components/dashboard/charts/GrossMarginChart.vue'
import RevenueTargetChart from '@/components/dashboard/charts/RevenueTargetChart.vue'
import QuarterGlanceChart from '@/components/dashboard/charts/QuarterGlanceChart.vue'
import MissingResourcesChart from '@/components/dashboard/charts/MissingResourcesChart.vue'
import BrokenEquipmentChart from '@/components/dashboard/charts/BrokenEquipmentChart.vue'
import PendingApprovalsChart from '@/components/dashboard/charts/PendingApprovalsChart.vue'

// Maps a template-chart tile key to its Vue component. Shared by DashboardPage,
// AddTileDialog and TemplateTile (keys match the backend DashboardTemplateChart.chart_key).
export const TILE_CHARTS = Object.freeze({
  'active-projects': ActiveProjectsChart,
  'pipeline-status': PipelineStatusChart,
  'company-overview': RevenueTargetChart,
  'quarter-glance': QuarterGlanceChart,
  'gross-margin': GrossMarginChart,
  'equipment-condition': EquipmentConditionChart,
  'on-time-repairs': OnTimeRepairsChart,
  'missing-resources': MissingResourcesChart,
  'broken-equipment': BrokenEquipmentChart,
  'pending-approvals': PendingApprovalsChart,
})

// Keys in TILE_CHARTS whose component renders a variable-length list rather than a
// fitted graph: their tile body scrolls vertically instead of clipping overflow.
export const TILE_LIST_KEYS = Object.freeze(new Set([
  'pending-approvals',
  'broken-equipment',
]))
